import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';
import { 
  CharacterAdvantage,
} from "@dndModels";
import { 
  DAMAGE_TYPES
} from "@dndModels/Constants";
import { DataType } from '@dndModels/Types';

import { makeStyles } from "@utilities/theme_utilities";

import ImageFromString from "@dndComponents/display/ImageFromString";
import InfoButton from "@components/input/buttons/InfoButton";
import FlexBox from '@components/layout/FlexBox';

interface Props {
  name?: string;
  disabled?: boolean;
  for_pdf?: boolean;
  width?: number;
  style?: React.CSSProperties | undefined;
  image?: string;
  find_images?: boolean;
  advantage?: number;
  advantages?: CharacterAdvantage[];
  greater_advantage?: boolean;
  minimum_roll?: number;
  flashing?: boolean;
  log_it?: boolean;
  data_type?: DataType | "";
  color?: string;
  onClick?: ((event: React.MouseEvent<HTMLDivElement>) => void) | null; 
  onMouseDown?: (event: React.MouseEvent<HTMLDivElement>) => void;
  split_commas?: boolean;
  className?: string;
  no_labs_button?: boolean;
  link_url?: string;
  small?: boolean;
}

export default function DandDButtonBox({
  name = "",
  disabled = false,
  for_pdf = false,
  width = -1,
  style = {},
  image = "",
  find_images = false,
  advantage = 0,
  advantages = [],
  greater_advantage = false,
  minimum_roll = 0,
  flashing = false,
  log_it = false,
  data_type = "",
  color,
  onClick = null,
  split_commas = false,
  className = "",
  onMouseDown,
  no_labs_button = false,
  link_url = "",
  small = false
}: Props) {
  const [is_flashing, setFlashing] = useState(flashing);
  const [last_advantage, setAdvantage] = useState(advantage);
  // const [last_advantages, setAdvantages] = useState(advantages.map(o => { return {...o}; }));
  const [last_greater_advantage, setGreaterAdvantage] = useState(greater_advantage);
  const [last_minimum_roll, setMinimumRoll] = useState(minimum_roll);
  const [reloading_name, setReloadingName] = useState(false);
  
  useEffect(() => {
    if (reloading_name) {
      setReloadingName(false);
    }
  }, [reloading_name]);

  useEffect(() => {
    setFlashing(flashing);
  }, [flashing]);

  useEffect(() => {
    if (last_advantage !== advantage) {
      setAdvantage(advantage);
    }
    // eslint-disable-next-line
  }, [advantage]);

  useEffect(() => {
    if (last_greater_advantage !== greater_advantage) {
      setGreaterAdvantage(greater_advantage);
    }
    // eslint-disable-next-line
  }, [greater_advantage]);

  useEffect(() => {
    if (last_minimum_roll !== minimum_roll) {
      setMinimumRoll(minimum_roll);
    }
    // eslint-disable-next-line
  }, [minimum_roll]);

  const useStyles = makeStyles()((theme) => {
    if (color) {
      return ({
        root: {
          color: color,
          '&:not(.borderless)': {
            borderColor: color,
            border: `1px solid`,
            borderRadius: '4px',
            marginBottom: '4px',
          },
        },
      });
    } else {
      return ({
        root: {
          '&:not(.borderless)': {
            border: `1px solid`,
            borderRadius: '4px',
            marginBottom: '4px',
          },
        },
      });
    }
  });

  const renderContent = () => {
    if (split_commas) {
      const pieces = name.split(",").map(o => o.trim());
      return pieces.map((piece, key) => {
        return (
          <FlexBox key={key}>{ renderContent2(piece) }</FlexBox>
        );
      });
    } else {
      return (
        <FlexBox>{ renderContent2(name) }</FlexBox>
      );
    }
  }

  const renderContent2 = (content: string) => {
    const pieces = content.split("|");
    const return_me: any[] = [];
    for (let i = 0; i < pieces.length; ++i) {
      const piece = pieces[i];
      if (find_images) {
        const strs = piece.split(/{|}|,/);
        for (const s of strs) {
          const s2 = s.trim();
          if (s2.length > 0) {
            if ((DAMAGE_TYPES as string[]).includes(s2)) {
              return_me.push(<ImageFromString key={return_me.length} image={s2} />);
            } else {
              return_me.push(<span key={return_me.length}>{s2}&nbsp;</span>);
            }
          }
        }
      } else {
        return_me.push(<span key={return_me.length}>{piece}</span>);
        if (image !== "") {
          return_me.push(<ImageFromString key={return_me.length} image={image} />);
        }
      }
      if (i + 1 < pieces.length) {
        return_me.push(<br key={return_me.length} />);
      }
    }
    // console.log(name);
    return return_me;
  }
  
  const { classes, cx } = useStyles();

  const my_className = `${className} ${no_labs_button ? "" : "labs_button"}${is_flashing ? " Flashing" : ""}${disabled ? " disabled" : ""}`;
  const single_row = advantage === 0 && minimum_roll === 0 && !name.includes("|"); // advantages.length === 0 && 

  const style2: React.CSSProperties = { width: (width > 0 ? `${width}px` : "100%"), boxSizing: "border-box" };
  if (small) {
    style2.lineHeight = 1.4;
  } else if (single_row) {
    style2.lineHeight = 2.5;
  } 
  if (log_it) {
    console.log(width);
    console.log(style);
    console.log(style2);
    
    debugger;
  }
  return (
    <div style={style2}>
      <FlexBox direction="column" className="centered" style={style2}>
        <FlexBox style={{ width: "100%" }}>
          { link_url ? (
            <a href={link_url}
              style={{ ...style, width: "auto", display: "block", textDecoration: "none", color: "inherit" }}
              className={ for_pdf ? "" : cx(classes.root, my_className)}
              onMouseDown={onMouseDown as unknown as React.MouseEventHandler<HTMLAnchorElement>}
              onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1) {
                  return;
                }
                if (!disabled && !for_pdf && onClick) {
                  onClick(event as unknown as React.MouseEvent<HTMLDivElement>);
                }
                event.preventDefault();
                return false;
              }}>
              <Grid container spacing={0} direction="row" style={{ height: "100%" }}>
                { renderContent() }
              </Grid>
            </a>
          ) : (
            <div style={{ ...style, width: "auto" }} 
              className={ for_pdf ? "" : cx(classes.root, my_className)} 
              onMouseDown={onMouseDown}
              onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                if (!disabled && !for_pdf && onClick) {
                  onClick(event);
                }
              }}>
              <FlexBox direction="column" style={{ height: "100%" }}>
                { renderContent() }
              </FlexBox>
            </div>
          )}
        </FlexBox>
        { advantage !== 0 && 
          <FlexBox style={{ height: "100%" }}>
            { advantage > 0 && greater_advantage ? 
              <span style={{ color: "green", fontWeight: "bold" }}>GR. ADV</span> 
            : advantage > 0 ? 
              <span style={{ color: "green" }}>ADV</span> 
            : advantage < 0 && 
              <span style={{ color: "red" }}>DISADV</span> 
            }
            <InfoButton>
              <Grid container spacing={0} direction="row" 
                style={{ maxHeight: window.innerHeight - 34 }}>
                <Grid size={12} className="header centered">
                  Advantage Source(s)
                </Grid>
                { advantages.map(a => {
                  return (
                    <Grid size={12} key={a.true_id}>
                      { a.advantage.disadvantage ? "Disadvantage" : "Advantage" }from { a.cfb_name }on { a.source_name }
                    </Grid>
                  );
                })}
              </Grid>
            </InfoButton>
          </FlexBox>
        }
        { minimum_roll > 0 && 
          <FlexBox style={{ color: "blue" }}>
            MIN { minimum_roll }
          </FlexBox>
        }
      </FlexBox>
    </div>
  );
}
